var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.18591L1.5558 5.30769C1.5558 5.30769 2.56307 4.44985 2.92569 4.44985C3.15094 4.44985 3.63078 4.73582 3.93296 5.72558C4.23515 6.71539 5.50749 11.8461 5.58488 12.0823C5.93265 13.1435 6.39068 15.1176 7.8009 15.4036C9.21112 15.6896 11.004 14.1279 11.9911 12.9841C12.9782 11.8403 16.8663 6.95732 17.0275 4.03192C17.1765 1.32699 16.3638 0.699356 16.0001 0.446638C15.3353 -0.0152738 14.2273 -0.169211 13.1797 0.226663C12.1322 0.622538 10.5407 1.92032 10.1176 4.22983C10.1176 4.22983 11.548 3.65796 12.0717 4.20782C12.5955 4.75768 12.4545 5.96746 12.0113 6.86928C11.5681 7.77109 10.3191 9.86067 9.85572 9.92666C9.39238 9.99264 9.02976 9.00283 8.96932 8.73888C8.90888 8.47493 8.14336 4.84568 7.86134 2.73413C7.57931 0.622588 6.35045 0.270638 5.7662 0.270638C5.18199 0.270688 4.17471 0.754612 0.75 4.18591Z",
    fill: "#4FC8FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.c2b0045521fb59319ed997a3993c2168.svg";
export { ForwardRef as ReactComponent };